<template>
	<v-container>
		<v-card>
			<v-card-title class="create-form-heading center"
				>Manage Distributors</v-card-title
			>
			<div class="input-block">
				<v-text-field
					label="Distributor ID"
					hide-details="auto"
					outlined
					v-model="distributorID"
					class="mb-3"
				></v-text-field>
				<v-btn
					depressed
					color="error"
					class="ml-0"
					@click="handleBlock(true)"
				>
					Block
				</v-btn>
				<v-btn depressed color="primary" @click="handleBlock(false)">
					Unblock
				</v-btn>
			</div>
			<v-snackbar bottom right v-model="alert.show"
				>{{ alert.text }}
			</v-snackbar>
		</v-card>
		<v-container>
			<v-btn
				depressed
				color="primary"
				v-if="!showBlockedDistributors"
				@click="getBlockedDistributors(TOP)"
			>
				Show Blocked Distributors</v-btn
			>
		</v-container>
		<v-container v-if="showBlockedDistributors" class="flex items-center">
			<v-data-table
				:headers="headers"
				:themeInputColor="themeInputColor"
				:items="distributors"
				:loading="loadDistributors"
			>
				<template v-slot:items="props">
					<tr>
						<td class="text-xs-center px-2">
							{{ props.item.userId }}
						</td>
						<td class="text-xs-center px-2">
							{{ props.item.retailerName }}
						</td>
					</tr>
				</template>
			</v-data-table>
			<v-row align="center">
				<v-btn
					:color="themeInputColor"
					class="white--text mt-3 mx-auto"
					@click="getBlockedDistributors(END)"
					v-if="offset"
					>Load More</v-btn
				>
			</v-row>
		</v-container>
	</v-container>
</template>
<script>
import { mapState } from "vuex";
import { BASE_URL } from "../../../config";
import ApiService from "@/store/api-service";
import { themeInputColor } from "@/utils";
import { TOP, END } from "@/store/config";
import { SHOW_ALERT } from "@/store/action-types";

export default {
	name: "ManageDistributors",
	data: () => ({
		themeInputColor: themeInputColor,
		distributorID: "",
		showBlockedDistributors: false,
		distributors: [],
		loadDistributors: false,
		offset: null,
		TOP: TOP,
		END: END,
		headers: [
			{
				text: "Distributor ID",
				value: "userId",
				align: "center",
				sortable: false
			},
			{
				text: "Distributor Name",
				value: "retailerName",
				align: "center",
				sortable: false
			}
		]
	}),
	methods: {
		handleBlock: async function(shouldBlock) {
			if (!this.distributorID) {
				this.showAlert("Please enter distributor ID");
				return;
			}
			const payload = {
				access_token: this.ACCESS_TOKEN,
				params: {
					userId: this.distributorID,
					updates: {
						isCommissionBlocked: shouldBlock
					}
				}
			};
			const endpoint = `${BASE_URL}/jeet11-finance/v1.0.0/adminRetailerSetting`;
			const response = await ApiService.post(endpoint, payload);
			this.showAlert(response.response.msg);
			if (response.response.msg.toLowerCase() === "success") {
				this.distributorID = "";
			}
			this.showSnackbar = true;
		},
		getBlockedDistributors: async function(type) {
			this.loadDistributors = true;
			const payload = {
				access_token: this.ACCESS_TOKEN,
				params:
					type === END
						? {
								offset: this.offset
						  }
						: {}
			};
			const endpoint = `${BASE_URL}/jeet11-finance/v1.0.0/blockedDistributors`;
			const response = await ApiService.post(endpoint, payload);
			if (
				response.statusCode === 200 &&
				response.response.status === "success"
			) {
				if (type === END) {
					this.distributors = [
						...this.distributors,
						...response.response.blockedDistributors
					];
				} else {
					this.distributors = response.response.blockedDistributors;
				}
				this.offset = response.response.offset;
				this.showBlockedDistributors = true;
				this.loadDistributors = false;
			}
		},
		showAlert(message) {
			this.$store.dispatch(SHOW_ALERT.dispatch, {
				text: message
			});
		}
	},
	computed: {
		...mapState({
			ACCESS_TOKEN: state => state.auth.ACCESS_TOKEN,
			alert: state => state.common.alert
		})
	}
};
</script>
<style scoped>
.input-block {
	display: inline-block;
	margin: 30px;
}
</style>
